import {
  Box,
  FormControl,
  FormHelperText,
  TextField,
  Typography,
} from '@mui/material'
import type { FC } from 'react'
import { Controller } from 'react-hook-form'
import { useLabelFormContext } from '../LabelForm/LabelFormContext'
import { useAreaFormContext } from './AreaFormContext'
import { AutoReadButton } from './autoRead/AutoReadButton'
import { useTextReader } from './autoRead/useAutoReader'

const alphanumericRegex = /^[a-zA-Z0-9]*$/

export const AlphanumericValue: FC = () => {
  const { control, formValues } = useAreaFormContext()
  const { formValues: labelFormValues } = useLabelFormContext()
  const { readText, isLoading } = useTextReader()

  const hasBBox = formValues.width > 0 && formValues.height > 0

  return (
    <Controller
      name="alphanumericValue"
      control={control}
      rules={{
        required: '1文字以上入力してください',
        pattern: {
          value: alphanumericRegex,
          message: '半角英数字で入力してください',
        },
        maxLength: { value: 20, message: '20文字以内で入力してください' },
      }}
      render={({ field, fieldState: { error } }) => (
        <FormControl error={!!error} required sx={{ gap: 0.5 }}>
          <Typography
            component="label"
            sx={{ color: 'text.primary', fontSize: 14, fontWeight: 'bold' }}
          >
            英数字の値
          </Typography>
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-end' }}>
            <TextField
              {...field}
              required
              fullWidth
              error={!!error}
              sx={{ backgroundColor: 'white' }}
            />
            <AutoReadButton
              imageUrl={labelFormValues.imageUrl}
              bbox={{
                x: formValues.x,
                y: formValues.y,
                width: formValues.width,
                height: formValues.height,
              }}
              disabled={!hasBBox}
              isLoading={isLoading}
              successMessage="英数字を読み取りました"
              onRead={value => field.onChange(value)}
              readFn={readText}
            />
          </Box>
          {error ? (
            <FormHelperText sx={{ margin: 0 }}>{error.message}</FormHelperText>
          ) : (
            <Typography variant="caption" color="text.secondary">
              半角英数字で入力してください（最大20文字）
            </Typography>
          )}
        </FormControl>
      )}
    />
  )
}
